import React from 'react';
import styled from 'styled-components';
import { SectionLabel } from '../shared';
import { SlideSection, SectionHeader, SplitGridList } from '../styles';
import { useSlideData } from '@context/slide-data';
import { GridListOption } from '../shared';
import { STATIC_IMAGES } from '@constants';

const ModificationStyle = styled.div`
    font-size: ${props => props.theme.smallFont};
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: flex-start;
`;

export const Modification = () => {
    const { data, slideState, sectionsVisible, desktop } = useSlideData();
    const { id } = data;
    const { certificate, stepOne, stepTwo, stepThree, stepFour } = STATIC_IMAGES;
    const selected = slideState.selectedSection ? slideState.selectedSection[id] : null;
    const imageType = 'image';
    const headerSize = '15px';

    return (
        <ModificationStyle>
            <SectionHeader>Steps</SectionHeader>
            <SlideSection
                flex={true}
                visible={sectionsVisible}
                selected={selected === 1}>
                    <SplitGridList desktop={desktop}>
                        <SectionLabel section={1} />
                        <GridListOption
                            headerSize={headerSize}
                            option={stepOne}
                            imageType={imageType}
                            step={1}/>
                        <GridListOption
                            headerSize={headerSize}
                            option={stepTwo}
                            imageType={imageType}
                            step={2}/>
                    </SplitGridList>
            </SlideSection>
            <SlideSection
                flex={true}
                visible={sectionsVisible}
                selected={selected === 2}>
                    <SplitGridList desktop={desktop}>
                        <SectionLabel section={2} />
                        <GridListOption
                            headerSize={headerSize}
                            option={stepThree}
                            imageType={imageType}
                            step={3}/>
                        <GridListOption
                            headerSize={headerSize}
                            option={stepFour}
                            imageType={imageType}
                            step={4}/>
                    </SplitGridList>
            </SlideSection>
            <GridListOption 
                headerSize={headerSize}
                step={5}
                imageType={imageType}
                option={certificate}/>
        </ModificationStyle>
    );
};

export default Modification;